import { memo } from "react"
import { Skeleton } from "@/components/ui/skeleton"
import { SkeletonAccordionItem } from "./accordion"

const TotalResultSkeleton = memo(() => (
  <div className="flex flex-col gap-8">
    <SkeletonAccordionItem defaultOpen />
    <SkeletonAccordionItem defaultOpen />
    <SkeletonAccordionItem defaultOpen />
  </div>
))

TotalResultSkeleton.displayName = `TotalResultSkeleton`

const SingleTableSkeleton = memo(() => (
  <Skeleton className="w-full rounded-lg animate-pulse min-h-[400px] h-full" />
))

SingleTableSkeleton.displayName = `SingleTableSkeleton`

export { TotalResultSkeleton, SingleTableSkeleton }
